import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$slug/fleet/$aircraftId/overview",
      params,
    })
  },
})
